// RETAIL PWA
<template>
<!-- Logged in user tool bar -->
    <div class="retailmain">
        <div  v-if="$store.getters.user && $user.userType=='business' ">
            <AppBar />
        </div>



        <v-overlay v-model="itemoverlayPlain"  >
            <v-progress-circular indeterminate size="64"></v-progress-circular>

        </v-overlay>


<!-- ##################### TOP LOGO ##################### -->
        <v-card  class="pb-80" elevation=24 v-if="isloaded">
                <div class="pa-auto">
                    <v-row class="ma-0 business-logo-top-center">
                        <v-col cols="12" v-if="business.logo=='null' || business.logo=='null'">
                            <h2> {{business.businessName}}</h2>
                        </v-col>
                        <v-col cols="12" v-else>
                            <img :src="business.logo" class="business-logo-top-center" :alt="business.businessName"/>
                        </v-col>
                    </v-row>
                </div>

                <!-- </v-card-title> -->

            <v-card-text class="pa-0 mb-auto">
                <v-tabs height="32" :color= business.themecolor   background-color="#fff" center-active show-arrows class="mt-5 ">


<!-- STICKY HEADER -->
                        <v-tabs-slider ></v-tabs-slider>
                        <v-tab  v-for="(item, index) in business.businessRetailCategory" :key="index"  class="">
                            {{ index }}
                        </v-tab>

<!-- Language Selector and Shopping Cart /Heart Icon                        -->
                        <v-tab-item v-for="(item, index) in business.businessRetailCategory" :key="index" class="pa-3" sticky-container>
                            <v-row  align="center" v-sticky style="background:#d4d4d4;" class="mb-3">
                                <v-col cols="8" class="">
                                    <div class="fixed-course-heading">
                                        {{ index }}
                                    </div>
                                </v-col>
                                <v-col cols="2" class="mid-mid">
                                        <!-- <v-icon v-if="foodview=='list'"
                                                class="grid-list-icons" @click="setview('grid','foodgrid-'+item[0].course_id)"
                                                color="#FE5800"
                                                size="18">mdi-grid-large
                                        </v-icon>
                                        <v-icon v-if="foodview=='grid'" class="grid-list-icons" @click="setview('list','foodgrid-'+item[0].course_id)"
                                            color="#FE5800"
                                            size="18">mdi-format-list-bulleted-square
                                        </v-icon> -->
                                        <v-menu class="" @click.native.stop  transition="fab-transition" v-if="business.hastranslations">
                                            <template v-slot:activator="{ on, attrs }"
                                            top
                                            left
                                            transition="scale-transition"
                                            >
                                                <v-btn @click.stop color="#FE5800" icon v-bind="attrs" v-on="on">
                                                    <v-avatar size="24" tile>
                                                        <img :src="'https://api.juzzap.com/flags/4x3/'+userlangcode+'.svg'" />
                                                    </v-avatar>
                                                    <!-- <v-icon class="compact-cogs-75">fa fa-cogs</v-icon> -->
                                                </v-btn>
                                            </template>

                                            <v-list dense no-gutters ma-0 pa-0 class="px-5 pt-1 white">
                                                <v-list-item v-for="(lang,ind) in business.translationlanguages" :key="'tl-'+ind">
                                                    <a @click.prevent="setlangcode(lang.languagecode)">
                                                        <div class="row">
                                                        <div class="col-3"><img :src="lang.photo"  :alt="lang.languagecode" width="16"/></div>
                                                        <div class="col-9">{{lang.lname+'('+lang.languagecode+')'}}</div>
                                                        </div>
                                                    </a>
                                                </v-list-item>
                                            </v-list>
                                        </v-menu>
                                    </v-col>

                                <div cols="2" class="">
                                    <v-row
                                        color=""
                                        class=""
                                        @click="gotoorder">

                                        <v-avatar class="favorite">
                                            <container class="favorite-count-cart">
                                                {{order.items.length}}
                                            </container>
                                            <v-icon class="favorite" color="#fe5800" size="30" style="font-size:30">mdi-cart</v-icon>
                                            <v-icon class="favorite" color="#fe5800" size="25" style="font-size:30" v-if="showcard==1">mdi-cart</v-icon>
                                            <v-icon class="favorite" color="#fe5800" size="25" style="font-size:30" v-else-if="showcard==0">mdi-heart</v-icon>
                                        </v-avatar>
                                    </v-row>
                                </div>
                            </v-row>

                            <v-row v-if="business.categorymaster[index].description!=''  &&  business.categorymaster[index].description!=null &&  business.categorymaster[index].description!='null'" class="food-course-top-banner" tile>
                                <v-col col="12" md="12" class="food-course-top-banner-description text-center">
                                    <!-- <span v-html="business.coursesmaster[index].price"></span> -->
                                    <span v-html="business.categorymaster[index].description"></span>

                                </v-col>
                            </v-row>


<!-- #################### Retail List View Product List View #####################  -->
                            <v-row v-if="retailview=='list'" class="">
                                <v-col class="" cols="12" v-for="(retailitem,ind) in item" :key="ind"
                                 :class="[retailitem.separation==1? '':'']" >
                                    <a @click.stop="retailitemdetails(retailitem.id,'','retail',retailitem.separation)">
                                        <v-card elevation=24
                                        class="max-400 image-listView" tile :class="retailitem.separation==1?'primary':''">
                                            <div no-gutters class="ma-0 pl-0 pt-0 pb-0">
                                                <div v-if="!retailitem.separation==1">
                                                <img v-if="retailitem.salepricediscountpercentage>0" :src="saleItem" class="saleitemcorner"/>
                                                    <span v-if="parseFloat(retailitem.salepricediscountpercentage)<10.00 && parseFloat(retailitem.salepricediscountpercentage)>0.00" class="sale-text-x">
                                                        -{{parseFloat(retailitem.salepricediscountpercentage).toFixed(0)}}%
                                                    </span>
                                                    <span v-if="parseFloat(retailitem.salepricediscountpercentage)>=10" class="sale-text">
                                                        -{{parseFloat(retailitem.salepricediscountpercentage).toFixed(0)}}%
                                                    </span>
<!-- ALTERNATIVE SALE ITEM MARKER                                                 -->
                                                <!-- <span class="sale-text">SALE</span> -->
                                                </div>
                                            </div>
<!-- SALE ITEM RIBBON  -->
                                            <!-- <div no-gutters class="ma-0 pl-0 pt-0 pb-0">
                                                <img :src="saleribbonItem" class="saleribbon"/>
                                            </div> -->

                                            <v-row class="mr-0">
                                                <v-col v-if="retailitem.separation==0" cols="4" class="pt-0 pb-0">
                                                    <v-avatar
                                                    size="100%"
                                                    tile
                                                    class="image-listView">
                                                        <v-img  :src="retailitem.fimage" class=""></v-img>
                                                    </v-avatar>
                                                </v-col>

<!-- COGS - DROPDOWN MENU -->
                                                <!-- <v-col cols="8" class="row-reset" style="width:100%"> -->
                                                <v-col :class="[retailitem.separation==1? 'cols-12' : 'cols-8']" class="pa-0 ma-0 row-reset" style="position:relative;width:100%">

                                                    <!-- <v-row style="justify-content: flex-end" class="bgr"  v-if="$store.getters.user && $user.userType=='business' && business.id==$user.business.id"> -->
                                                    <v-row v-if="$store.getters.user && $user.userType=='business' && business.id==$user.business.id">
                                                        <v-col cols="12" class="ma-0 pa-0 text-right pr-3">
                                                                <v-menu @click.native.stop transition="fab-transition">
                                                                    <template v-slot:activator="{ on, attrs }"
                                                                    bottom
                                                                    left
                                                                    transition="fab-transition"
                                                                    v-model="closeOnContentClick">

                                                                        <v-btn @click.stop flex color="#FE5800" icon v-bind="attrs" v-on="on" class="pr-4">
                                                                            <!-- <v-icon>fa fa-cog fa-spin</v-icon> -->
                                                                            <v-icon>fa fa-cogs</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                        <v-icon color="red" icon dark class="text-right close-menu-right pa-0 ma-0 pt-2 pr-3">mdi-close-circle</v-icon>

                                                                        <v-list dense no-gutters ma-0 pa-0 class="text-left px-5 pt-4">
                                                                        <v-list-item class="text-left">
                                                                            <span class="mt-4 edit-item-name">
                                                                                {{retailitem.retailitemname}}
                                                                                {{userlangcode==''?retailitem.retailitemname:retailitem.langtransaltions[userlangcode].title}}
                                                                            </span>
                                                                        </v-list-item>
                                                                        <v-list-item class="menuleft">
                                                                            <div class="ma-0 pa-0"  v-if="retailitem.showonmenu==1">
                                                                            <v-switch no-gutters style="font-size:12px !important;" color="success" :input-value="shw"  @click.stop="updateshowitem(retailitem.id,0)" :id="'showonitem-'+item.id"></v-switch>
                                                                        </div>
                                                                        <div class="d-flex" v-else>
                                                                            <v-switch no-gutters style="font-size:12px !important;" color="" :input-value="nshw"  @click.stop="updateshowitem(retailitem.id,1)" :id="'showonitem-'+item.id"></v-switch>
                                                                        </div>
                                                                        </v-list-item>
                                                                        <v-list-item class="menuleft">
                                                                            <v-btn icon @click.prevent="retailitemimage(retailitem.id,retailitem.showonmenu)" color="#FE5800 " fab x-small dark class="ma-0 pa-0">
                                                                                <v-icon class="pr-2">mdi-camera-plus-outline</v-icon>
                                                                                <!-- <span class="edit-item-name">{{$t('zz_change_image')}}</span> -->
                                                                            </v-btn>
                                                                        </v-list-item>
                                                                        <v-list-item class="menuleft">
                                                                            <v-btn icon @click="edititem(retailitem.id)"  color="#FE5800 " fab x-small dark class="ma-0 pa-0">
                                                                                <v-icon class="pr-2">mdi-square-edit-outline</v-icon>
                                                                                <!-- <span class="edit-item-name">{{$t('zz_edit')}}</span> -->
                                                                            </v-btn>
                                                                        </v-list-item>
                                                                        <v-list-item class="menuleft">
                                                                            <v-btn icon @click="deleteItem(retailitem.id)"  color="#FE5800 " fab x-small dark class="ma-0 pa-0">
                                                                                <v-icon class="pr-2">mdi-trash-can-outline</v-icon>
                                                                                <!-- <span class="edit-item-name">  {{$t('zz_delete')}}</span> -->
                                                                            </v-btn>
                                                                        </v-list-item>
                                                                    </v-list>
                                                                </v-menu>
                                                        </v-col>
                                                    </v-row>
                                                    <v-row class="row-reset">
                                                        <v-col cols="12" class="row-reset pr-2 pb-1">
                                                            <div :class="[retailitem.separation==1?'pt-0 pb-0':'pb-10']">
                                                                <!-- :class="[showcard?'favorite-count-cart':'favorite-count-heart']"> -->
                                                                <v-row class="row-reset" v-if="retailitem.retailitemname!='NULL' || retailitem.retailitemname!=NULL">
                                                                    <v-col v-if="retailitem.separation==1" cols="12" md="12" :class="[retailitem.separation==1? 'retailitem-separation-list-view-title cols=12':'title-listView row-reset pt-2' ]">
                                                                        {{userlangcode==''?retailitem.retailitemname:retailitem.langtransaltions[userlangcode].title}}
                                                                    </v-col>
                                                                    <v-col v-else cols="9" md="9" :class="[retailitem.separation==1? 'retailitem-separation-list-view-title cols=12':'title-listView row-reset pt-2' ]">
                                                                        <!-- {{retailitem.retailitemname}} -->
                                                                        {{userlangcode==''?retailitem.retailitemname:retailitem.langtransaltions[userlangcode].title}}
    <!-- TITLE  -->
                                                                    </v-col>
                                                                    <v-col cols="3" md="3" class="row-reset prod-code-listView" v-if="retailitem.separation==0">
                                                                        {{retailitem.productcode}}
                                                                    </v-col>
                                                                </v-row>
    <!-- SUBTITLE  -->
                                                                <v-row class="row-reset" v-if="retailitem.subtitle!='NULL' || retailitem.subtitle!=NULL || retailitem.separation==1">
                                                                    <v-col cols="12" md="12" :class="[retailitem.separation==1? 'retailitem-separation-list-view-subtitle':'subtitle-listView' ]">
                                                                        <!-- {{retailitem.subtitle}} -->
                                                                        {{userlangcode==''?retailitem.subtitle:retailitem.langtransaltions[userlangcode].subtitle}}
                                                                    </v-col>
                                                                </v-row>
    <!-- BRAND  -->
                                                                <v-row class="row-reset" v-if="retailitem.brand!='NULL' || retailitem.brand!=NULL">
                                                                    <v-col cols="12" md="12" class="brand-listView" v-if="retailitem.separation==0">
                                                                        {{retailitem.brand}}
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row class="row-reset">
                                                                    <v-col cols="12" md="12" class="description-listView"  v-if="retailitem.separation==0">
                                                                        <p v-html="userlangcode==''?retailitem.description:retailitem.langtransaltions[userlangcode].description">
                                                                        </p>
                                                                    </v-col>
                                                                </v-row>
                                                            </div>
<!-- PRICE SECTION  -->
                                                            <div class="retail-price-section ">
                                                                <v-row>
                                                                    <v-col cols="12" md="12" class="pa-0 ma-0 pl-3 price-row-listView"  v-if="retailitem.separation==0">
                                                                 <!-- <v-row cols="12" class="row-reset price-row-listView retail-price-section mt-10"  v-if="!retailitem.separation"> -->
                                                                <!-- <div  v-if="!retailitem.separation"> -->
                                                                    <v-row class="pl-3 pr-6">
                                                                    <v-col cols="6" md="6" class="size-portion-text-listView"  v-if="retailitem.size!='NULL' || retailitem.size!=NULL">
                                                                        {{retailitem.size}}
                                                                    </v-col>
                                                                    <v-col cols="5" md="5" class="ma-0 pt-0 pb-0 pl-0 pr-1 text-end">

                                                                        <span v-if="parseFloat(retailitem.saleprice)>0.001" class="strikethrough was-price-listView">
                                                                            {{parseFloat(retailitem.price).toFixed(2)}}
                                                                        </span>

                                                                        <!-- <span v-else-if="retailitem.saleprice<=0.01" class="sale-price-listView">
                                                                            {{retailitem.saleprice.toFixed(2)}}
                                                                        </span> -->

                                                                        <!-- <span class="discount-listView"  v-if="parseFloat(retailitem.salepricediscountpercentage)>0.01">
                                                                        -{{parseFloat(retailitem.salepricediscountpercentage).toFixed(0)}}%
                                                                        </span> -->

                                                                        <span v-if="parseFloat(retailitem.saleprice)>0.001" class="price-listView">
                                                                            {{parseFloat(retailitem.saleprice).toFixed(2)}}
                                                                        </span>
                                                                        <span v-else-if="parseFloat(retailitem.price)>0.001" class="price-listView">
                                                                            {{parseFloat(retailitem.price).toFixed(2)}}
                                                                        </span>
                                                                    </v-col>
                                                                <!-- </div> -->
                                                                <v-col cols="1" class="text-end row-reset pr-1 " v-if="checkitemfavorite(retailitem.id,retailitem.course_id)">
                                                                        <v-icon  @click.stop="togglefav(retailitem.id,retailitem.course_id,index,parseFloat(retailitem.saleprice)>0?retailitem.saleprice:retailitem.price,retailitem.fimage,retailitem.title,retailitem.subtitle,retailitem.price)" size="20" color="#fe5800">mdi-cart</v-icon>
                                                                    </v-col>
                                                                    <v-col cols="1" class="text-end row-reset pr-1" v-else>
                                                                        <v-icon   @click.stop="togglefav(retailitem.id,retailitem.course_id,index,parseFloat(retailitem.saleprice)>0?retailitem.saleprice:retailitem.price,retailitem.fimage,retailitem.title,retailitem.subtitle,retailitem.price)" size="16" color="#fe5800">mdi-cart-outline</v-icon>
                                                                    </v-col>
                                                                    </v-row>
                                                                    </v-col>
                                                                </v-row>
                                                            </div>
                                                            <!-- </v-col> -->
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>

                                        </v-card>
                                    </a>
                                </v-col>

                            </v-row>
                        </v-tab-item>

                </v-tabs>
            </v-card-text>

        </v-card>
<!-- ¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢ORDER CARD DIALOG ¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢¢ -->
        <v-dialog v-model="orderdialog" content-class="orderdetaildialog" scrollable fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card v-if="orderdialog==true" tile class="" elevation="3" color="#fff">
                <ordercomponent   :orderdetail="order" :ordercourses="ordercourses" :business="business" v-on:set-dialog="backtofood" v-on:deleteitem="deleteorderitem" v-on:setordercoursesitem="updateorder" v-on:saveorderitem="saveorder"/>
            </v-card>
        </v-dialog>
<!-- END OF ORDER DETAIL CARD AND PAYMENTS  -->


<!-- RETAIL ITEM DETAIL CARD/PRODUCT DETAIL CARD  -->

        <v-dialog v-model="itemdialog" content-class="itemdetaildialog" scrollable fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card tile class="detail-card-retail" elevation="3" v-show="retailitemid>0">
                <v-card class="ma-0 pa-0">
                                <!-- <v-overlay v-model="itemoverlayPlain"  >
                                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                                </v-overlay> -->
                        <v-overlay v-model="orderoverlayPlain" z-index="99999" >
                            <v-progress-circular indeterminate size="64"></v-progress-circular>
                        </v-overlay>
                        <v-img
                            min-width="100%"  class="detail-card-food"
                              :src="retailitem.fimage">
                        </v-img>




                        <!-- <img :src="editimageicon" v-if="$store.getters.user && $user.userType=='business' && business.id==$user.business.id" width="28" @click.prevent="retailitemimage(retailitem.id,retailitem.showonmenu)"
                        color="#fe5800" style="top:10px;right:10px;position:absolute;z-index=99999;"/> -->
                        <v-row class="ma-0" style="">
                            <v-col cols="12" class="ml-auto text-right pb-0" v-if="retailitemid.id!=0 && checkitemfavorite(retailitem.id,retailitem.course_id)">
                            <!-- <a @click="togglefav(retailitem.id,retailitem.courses[0].cid,retailitem.courses[0].coursename,retailitem.courses[0].price,retailitem.fimage,retailitem.title,retailitem.subtitle)">
                                    <img :src="imgfavminus" width="30" />
                                </a>-->
                               <v-icon  @click.stop="togglefav(retailitem.id,retailitem.course_id,retailitem.course_name,parseFloat(retailitem.saleprice)>0?retailitem.saleprice:retailitem.price,retailitem.fimage,retailitem.title,retailitem.subtitle,retailitem.price)" size="16" color="#fe5800">mdi-cart</v-icon>
                            </v-col>
                            <v-col cols="12" class="ml-auto text-right pb-0" v-else>
                            <!-- <a @click="togglefav(retailitem.id,retailitem.courses[0].cid,retailitem.courses[0].coursename,retailitem.courses[0].price,retailitem.fimage,retailitem.title,retailitem.subtitle)">
                                    <img :src="imgfavplus" width="30" />
                                </a> -->
                                <v-icon  @click.stop="togglefav(retailitem.id,retailitem.course_id,retailitem.course_name,parseFloat(retailitem.saleprice)>0?retailitem.saleprice:retailitem.price,retailitem.fimage,retailitem.title,retailitem.subtitle,retailitem.price)" size="16" color="#fe5800">mdi-cart-outline</v-icon>
                            </v-col>
                            <v-col cols="12" class="text-right" v-if="$store.getters.user && $user.userType=='business' && business.id==$user.business.id">





                            <span cols="12" class="mr-auto text-right" v-if="$store.getters.user && $user.userType=='business' && business.id==$user.business.id">
                                <v-icon style="top: 10%; right:0px; position:fixed; z-index=11" class="white-compact-cogs-75 cogtab " size="26" @click.stop="edititem(retailitem.id)">fa fa-cogs</v-icon>
                            </span>

                            </v-col>
                        </v-row>
                        <v-row class="row-reset pa-0 ma-0">
                                <v-col cols="12" class="retail-detail-prod-code">
                                    <div>{{retailitem.productcode}}</div>
                                </v-col>
                        </v-row>

                        <v-col cols="12" md="12" sm="12">
                            <v-row class="detail-card-section">
                                <v-col cols="12" md="12" sm="12">
                                    <div class="retail-detail-card-title">
                                        <!-- {{retailitem.title}} -->
                                        {{itemdialog?(userlangcode=='' ?retailitem.title:retailitem.langtransaltions[userlangcode].title):retailitem.title}}

                                    </div>
                                    <div class="retail-detail-card-subtitle">
                                        <!-- {{retailitem.subtitle}} -->
                                        {{itemdialog?(userlangcode=='' ?retailitem.subtitle:retailitem.langtransaltions[userlangcode].subtitle):retailitem.subtitle}}

                                    </div>
                                </v-col>
                            </v-row>
                            <v-row class="row-reset">
                                <v-col cols="12" class="retail-detail-prod-code">
                                    <!-- <div>{{retailitem.productcode}}</div> -->
                                    <span class="retail-discount-listView"  v-if="parseFloat(retailitem.salepricediscountpercentage)>0.00">
                                                                        -{{parseFloat(retailitem.salepricediscountpercentage).toFixed(0)}}%
                                                                        </span>
                                </v-col>

                                <v-col cols="12" md="12" sm="12" class="retail-detail-card-item-price">
                                    <!-- <v-col cols="8" md="8" class="ma-0 pt-0 pb-0 pl-0 pr-1 text-end"> -->

                                                                        <span v-if="parseFloat(retailitem.saleprice)>0.001" class="strikethrough was-price-listView">
                                                                            {{parseFloat(retailitem.price).toFixed(2)}}
                                                                        </span>

                                                                        <!-- <span v-else-if="retailitem.saleprice<=0.01" class="retail-sale-price-listView">
                                                                            {{retailitem.saleprice.toFixed(2)}}
                                                                        </span> -->

                                                                        <!-- <span class="retail-discount-listView"  v-if="parseFloat(retailitem.salepricediscountpercentage)>0.01">
                                                                        -{{parseFloat(retailitem.salepricediscountpercentage).toFixed(0)}}%
                                                                        </span> -->

                                                                        <span v-if="parseFloat(retailitem.saleprice)>0.001" class="price-listView">
                                                                            {{parseFloat(retailitem.saleprice).toFixed(2)}}
                                                                        </span>
                                                                        <span v-else-if="parseFloat(retailitem.price)>0.001" class="sale-price-listView">
                                                                            {{parseFloat(retailitem.price).toFixed(2)}}
                                                                        </span>
                                                                    <!-- </v-col> -->

                                    <!-- <div>{{retailitem.price}}  {{parseFloat(retailitem.price).toFixed(2)}}</div> -->
                                </v-col>
                            </v-row>
                            <v-row class="row-reset">

                                <v-col cols="12" class="retail-detail-card-description"
                                    v-html="itemdialog?(userlangcode=='' ?retailitem.description:retailitem.langtransaltions[userlangcode].description):retailitem.description">
                                </v-col>
                            </v-row>
                        </v-col>
                        <p class="powered-by-juzzap">powered by juZZap</p>
                </v-card>





            </v-card>

            <v-footer
                fixed
                bottom:50px
                class="font-weight-medium "
                color="transparent">
                    <v-col
                        class="text-center"
                        cols="12"
                    >
                        <v-btn  @click="itembacktomenu" fab small color="#fe5800">
                            <v-icon class="white--text">mdi-close</v-icon>

                        </v-btn>
                    </v-col>
            </v-footer>


        </v-dialog>

        <v-dialog v-model="itemimagedialog" content-class="itemdetaildialog" scrollable fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card tile class="" elevation="3" color="#fff"   >
                <v-card-text class="pa-0 carddetail" elevation="3" color="#fff">

                    <v-form v-model="valid" enctype="multipart/form-data" id="editretailitem">

                        <v-row>
                            <v-col cols="9" md="9" class="font-weight-bold pb-0" style="font-size:18px;" >
                            Show On Menu
                            </v-col>
                            <v-col cols="3" md="3" class="pb-0">
                                <div v-if="retailitemshowonmenu==1 ">
                                    <v-switch  color="success" :input-value="shw" @click="updateshowitem(itemupdateid,0)"   :id="'showonitem-'+itemupdateid"></v-switch>
                                </div>
                                <div v-else>
                                    <v-switch  color="" :input-value="nshw" @click="updateshowitem(itemupdateid,1)"  :id="'showonitem-'+itemupdateid"></v-switch>

                                </div>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="12" class="text-center"><h4>Update Image</h4></v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" md="12" sm="12">

                            <v-row v-if="mainimguploading">
                                <v-col cols="12" class="text-center">
                                    <v-progress-circular
                                    indeterminate
                                    color="primary"
                                    ></v-progress-circular>
                                </v-col>
                            </v-row>

                            <Cropper v-show="uploadedimage!=null && uploadedimage!='null' " class="cropper" :src="uploadedimage" @change="onChange" :stencilProps="{aspectRatio: 16/9}"/>

                            <v-row>
                                <v-col cols="12" md="12" sm="12" class="text-center mb-5 mt-3" >

                                <v-img class="backimg"  :src="addphoto" @click="$refs.file.click()" style="max-height:200px;background-size: contain;">
                                    <input
                                    type="file"
                                    ref="file"
                                    @change="uploadImage($event)"
                                    accept="image/*"
                                    class=""
                                    id="itemimage"
                                    />
                                </v-img>
                                </v-col>

                                <v-col cols="12" md="12" sm="12" class="text-center mb-9">
                                    <v-btn color="primary" block large @click.stop="updateimage">Update</v-btn>

                                </v-col>

                            </v-row>

                            </v-col>
                        </v-row>

                    </v-form>


                </v-card-text>

            </v-card>

            <v-footer
            absolute
            class="font-weight-medium "
            color="transparent">
                <v-col
                    class="text-center"
                    cols="12">
                    <v-btn @click="backtomenuimage" fab small color="#fe5800" >
                        <v-icon class="white--text ">mdi-close</v-icon>
                    </v-btn>
                </v-col>
            </v-footer>
        </v-dialog>



    </div>
</template>
<script>
    import Vue from 'vue'
    import { Cropper } from 'vue-advanced-cropper'
    import AppBar from '@/components/AppBar.vue'
    import ordercomponent from '@/components/OrderComponent.vue';
    export default {
        props:['business','order','isloaded','tag'],

        data: () =>
        ({
            otype:'retail',
            drawer:null,
            fooditemshowonmenu:0,
            retailitemshowonmenu:0,
            itemupdateid:0,
            mainimguploading:false,
            uploadedimage:null,
            addphoto: require("@/assets/addphoto.svg"),
            cheficonList:require('@/assets/chefList.svg'),
            saleItem:require('@/assets/Sale-Item-Corner.svg'),
            saleribbonItem:require('@/assets/Sale-Item-Ribbon.svg'),



            itemimagedialog:false,
            itemdialog:false,
            image:'',
            createaccount:0,
            showpayment:0,
            savedorder:[],


            nameRules: [
            v => !!v || 'Name is required',
            v => (v && v.length <= 20) || 'Name must be less than 20 characters',
            ],
            emailRules:
            [
            v => !!v || 'E-mail is required',
            v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
            ],
            orderoverlayPlain:false,
            itemoverlayPlain:false,
            retailview:'list',
            orderdialog:0,
            ordercourses:{'courses':[{'items':[]}]},
            localorder:[],
            currentorder:[{items:[]}],
            fooditemid:0,
            courseid:0,
            itemqty:1,
            fooditem:
            {
                "id":0,
                "showonmenu":0,
                "business_id":0,
                "department_id":0,
                "title":"",
                "subtitle":"",
                "description":"",
                "image":"",

                "chillispice":0,
                "created_at":"",
                "updated_at":"",
                "foodstatus":"",
                "viewed":0,
                "ordered":0,
                "fimage":"",
                "meats":[],
                "diets":[],
                "poultrys":[],
                "allergens":[],
                "courses":[],
                "drinkitems":[],
            },
            retailitem:
            {

                "viewed":0,
                "ordered":0,
                "fimage":"",
                "image":"",
                "allergens":[],
                "measures":[],
                "units":[],
                "categories":[],
                "types":[],
                "langtransaltions":[],
            },

            cocacolaImg:require('@/assets/cocacola2.gif'),
            overlaycocacola:false,
            orderoverlayPlain:false,
            overlayPIN:false,
            drinkoverlayPlain:false,
            overlayfooditem:false,
            overlayfooditemdetail: false,
            orderoverlay:false,
            orderrating:0,
            ordername:'',
            orderpanel:[0,1],
            valid:true,
            shw:true,
            nshw:false,
            retailitemid:0,
            editicon:require("@/assets/Pen-Icon-01.svg"),
            imgicon:require("@/assets/Camera-Icon-01.svg"),
            editimageicon:require("@/assets/editphotoicon.svg"),
            userlangcode:'',

        }),

        watch:
        {
            business:function(value)
            {
                this.userlangcode=localStorage.getItem('langcode-'+this.business.id)||'';
        if(!this.userlangcode){
          this.userlangcode="";
        }

                return value;
            },
            order:function(value)
            {
                return value;
            }
        },
        components: {
            Cropper,
            AppBar,
            ordercomponent
        },
        created()
        {
            console.log('business data'+this.business);
           this.userlangcode=localStorage.getItem('langcode-'+this.business.id)||'';
        if(!this.userlangcode){
          this.userlangcode="";
        }


        },

        mounted()
        {
            if(localStorage.getItem('order-'+this.business.id))
            {
                let corder=JSON.parse(localStorage.getItem('order-'+this.business.id));
                this.order.items=corder.items;
                this.order.name=corder.name?corder.name:'';
                this.order.phone=corder.phone?corder.phone:'';
                this.order.address1=corder.address1?corder.address1:'';
                this.order.address2=corder.address2?corder.address1:'';
                this.order.zip=corder.zip?corder.zip:'';
                this.order.town=corder.town?corder.town:'';



                this.order.ordertype=corder.ordertype?corder.ordertype:'';
            //  this.order=JSON.parse(localStorage.getItem('order-'+this.business.id));
            }else
            {
                localStorage.setItem('order-'+this.business.id,JSON.stringify({'ordertype':'','name':'','phone':'','address':'','items':[]}));
                this.order=JSON.parse(localStorage.getItem('order-'+this.business.id));
            }
            this.userlangcode=localStorage.getItem('langcode-'+this.business.id)||'';
        if(!this.userlangcode){
          this.userlangcode="";
        }
        },

        computed:
        {
            ordertotal:function(){
                let total=0;
                this.order.items.forEach(function(item,inx){
                    total+=parseFloat(item.qty)*parseFloat(item.price);
                })
                return total.toFixed(2);
            }
        },

        methods:
        {
            updateorder()
            {
                //alert('this');
                console.log('emit');
                this.order=JSON.parse(localStorage.getItem('order-'+this.business.id));
            },
            backtofood()
            {
                this.orderdialog=false;
            },
            deleteItem(item)
            {
                if (confirm("Are you sure you want to delete this Retail Item?"))
                {
                    this.overlay=true;

                    this.$http
                    .post(this.$apidomain+"deleteretailItem/"+item)
                    .then(res => {

                        this.overlay=false;

                        this.$router.go('/');

                    })
                        .catch(err => {
                                console.log(err.response);
                        });
                }
            },
            setlangcode(langcode)
            {
              localStorage.setItem('langcode-'+this.business.id,langcode)
              this.userlangcode=localStorage.getItem('langcode-'+this.business.id)||'';
              if(!this.userlangcode){
                this.userlangcode="";
              }
            },
            whatsapmsg()
            {


                let th=this;




                let newstr=[];

                let whatsaapMsg="";

                th.whatsaapNumber=th.business.whatsapp;




                let total=0;

                if(th.ordercourses.courses.length>0)
                {
                    let itemfound=false;
                    let ordertotal=0;

                    let paymentmode='';

                    th.strmsg="\n\n\n*CLIENTE*\n\n";


                    th.strmsg+="_"+th.order.name+"_\n\n";

                    if(th.order.ordertype=='Delivery'){

                        th.strmsg+="\n"+th.order.address1;
                        th.strmsg+="\n"+th.order.address2;
                        th.strmsg+="\n"+th.order.city+", "+th.order.town;
                        th.strmsg+="\n"+th.order.zip;



                        if(th.order.paymentmode!='')
                        {
                            th.paymentmode=th.order.paymentmode;
                        }


                    }

                    let allAllerText="";

                    let allAllergenname="";

                    allAllergenname=JSON.parse(localStorage.getItem('jzAllergensName'));



                    if(allAllergenname)
                    {
                        allAllergenname.forEach(function(allergen,ind){



                            allAllerText+=allergen.replace('<br>',' ')+', ';
                        })

                        allAllerText=allAllerText.substr(0,allAllerText.length-1);

                    }

                    if(allAllerText=='')
                    {
                        th.strmsg+="\n\n*ALLERGENS:* None declared  \n\n";

                    }
                    else
                    {
                        th.strmsg+="\n\n*ALLERGENS:* "+allAllerText+" \n\n";
                    }

                    th.strmsg+="*Notes:* \n";


                    th.strmsg+=th.order.phone;


                    th.strmsg+="\n\n.............................\n";

                    th.strmsg+="*"+th.business.businessName+"* \n";

                    th.strmsg+=this.$domain+"businessDetails/"+th.business.businesscode+"/drink \n\n";


                    th.strmsg+="*TYPO:"+th.order.ordertype+"*";
                    th.strmsg+="\n.............................\n";



                    th.ordercourses.courses.forEach(function(item,index){

                        if(item.items.length>0)
                        {

                            th.strmsg+="\n\n*"+item.coursename+"*\n\n";

                            item.items.forEach(function(it,ind){
                                if(it.qty>0 && it.price>0)
                                {
                                    th.strmsg+=it.qty+" X "+it.title+" = "+th.business.currency.symbole+(parseFloat(it.qty)*parseFloat(it.price)).toFixed(2)+"\n";
                                    ordertotal+=parseFloat(it.qty)*parseFloat(it.price);
                                }
                            })




                        }



                    })

                    th.strmsg+="\n..........................\n";



                    th.strmsg+="*Total :"+th.business.currency.symbole+ordertotal.toFixed(2)+"*";

                    th.strmsg+="\n\n";

                    if(th.paymentmode!='')
                    {
                        th.strmsg+="*Payment Mode* :"+th.paymentmode;


                        th.strmsg+="\n\n";

                    }


                    th.strmsg+="*DELIVERY CHARGES:* \n";

                    if(parseFloat(ordertotal)>parseFloat(th.business.deliveryfreeorder))
                    {
                        th.strmsg+="FREE This is on us, Thanks For Your Order \n";

                    }
                    else
                    {
                        th.strmsg+="If you order just another "+th.business.currency.symbole+(parseFloat(th.business.deliveryfreeorder)-parseFloat(ordertotal)).toFixed(2)+" you will save the delivery fee.";

                    }




                    //th.strmsg+="\n\n powered by juZZap \n\n";





                    whatsaapMsg="https://wa.me/"+th.business.whatsapp+"/?text="+encodeURIComponent(th.strmsg);

                    window.location=whatsaapMsg;



                }
            },

            saveorder()
            {
                let th=this;


                let msg="";
                let response="";
                if (this.$refs.form.validate())
                {

                    let fd = new FormData(document.getElementById("createorder"));

                    if(th.ordercourses.courses.length>0)
                    {
                        let ordertotal=0;

                        let orderitems=[];

                        let createaccount=0;

                        if(th.createaccount)
                        {
                            createaccount=1;
                        }
                        else
                        {
                            createaccount=0;
                        }

                        fd.append('createaccount',createaccount);


                        fd.append('name',th.order.name);

                        fd.append('orderid','order-'+th.business.id)

                        fd.append('businesses_id',th.business.id)

                        fd.append('paymentmode',th.order.paymentmode)

                        th.ordercourses.courses.forEach(function(item,index)
                        {

                            if(item.items.length>0)
                            {


                                item.items.forEach(function(it,ind){
                                    if(it.qty>0 && it.price>0)
                                    {
                                        orderitems.push({'product_type':it.type,'course_id':it.courseid,'product_name':it.title,'product_id':it.itemid,'qty':it.qty,'price':it.price,'total':parseFloat(it.qty)*parseFloat(it.price)});
                                        ordertotal+=parseFloat(it.qty)*parseFloat(it.price);
                                    }
                                })

                            }



                        })

                        fd.append('ordertotal',ordertotal);

                        fd.append('addressline1',th.order.address1);

                        fd.append('addressline2',th.order.address2);

                        fd.append('city',th.order.city);

                        fd.append('town',th.order.town);

                        fd.append('zip',th.order.zip);

                        fd.append('notes',th.order.phone);

                        fd.append('orderitems',JSON.stringify(orderitems));







                    }

                    this.$http
                    .post(this.$apidomain+"createorder", fd)
                    .then(res =>
                    {
                        th.msg=res.data.msg;
                        th.response=res.data.success;



                            if(res.data.success==1)
                            {
                                this.savedorder=res.data.ordermaster;
                                if(res.data.key.clientSecret!='' && this.business.paymentenabled==1)
                                {

                                    this.stripe = this.business.stripapikey;
                                    if(this.business.stripapikey!=''){
                                        var stripe = Stripe(this.stripe);
                                        let elements = stripe.elements();

                                        let card = elements.create("card");

                                        // Stripe injects an iframe into the DOM

                                        var style = {

                                            base: {

                                                color: "#32325d",

                                                fontFamily: 'Arial, sans-serif',

                                                fontSmoothing: "antialiased",

                                                fontSize: "16px",

                                                "::placeholder": {

                                                color: "#32325d"

                                                }

                                            },

                                            invalid: {

                                                fontFamily: 'Arial, sans-serif',

                                                color: "#fa755a",

                                                iconColor: "#fa755a"

                                            }

                                            };

                                        card.mount("#card-element", { style: style });
                                        th.showpayment=1;
                                        document.querySelector("#payment-form button").disabled = true;

                                        card.on("change", function (event)
                                        {

                                            // Disable the Pay button if there are no card details in the Element

                                            document.querySelector("#payment-form button").disabled = event.empty;

                                            document.querySelector("#card-error").textContent = event.error ? event.error.message : "";

                                        });

                                        var form = document.getElementById("payment-form");

                                        form.addEventListener("submit", function(event) {

                                        event.preventDefault();

                                        // Complete payment when the submit button is clicked

                                        th.payWithCard(stripe, card, res.data.key.clientSecret);

                                        });
                                    }
                                }




                                //th.whatsapmsg()

                            }



                    })
                    .catch(err => {
                        //this.overlay=false;

                    console.log(err.response);
                    });



                }
            },

            edititem(itemid)
            {
                this.$router.push({name:'editretailitem',params:{id:itemid}});

            },

            addorderqty(itemid,courseid)
            {
                let th=this;

                th.order.items.forEach(function(item,index){
                    if(item.itemid==itemid && item.courseid==courseid)
                    {
                        //th.order.items.splice(index,1);
                        item.qty++;
                        item.total=parseFloat(item.qty)*parseFloat(item.price);
                    }
                });

                localStorage.setItem('order-'+this.business.id,JSON.stringify(this.order));

                this.setordercourses();
            },

            reduceqty(itemid,courseid)
            {
                let th=this;

                th.order.items.forEach(function(item,index){
                    if(item.itemid==itemid && item.courseid==courseid)
                    {
                        //th.order.items.splice(index,1);
                        if(item.qty>0)
                        {
                            item.qty--;
                            item.total=parseFloat(item.qty)*parseFloat(item.price);

                        }
                    }
                });

                localStorage.setItem('order-'+this.business.id,JSON.stringify(this.order));

                this.setordercourses();
            },
            deleteorderitem(itemid,courseid)
            {

                let th=this;

                th.order.items.forEach(function(item,index){
                    if(item.itemid==itemid && item.courseid==courseid)
                    {
                        th.order.items.splice(index,1);

                    }
                });
                // this.order.items.splice(ind,1);

                localStorage.setItem('order-'+this.business.id,JSON.stringify(this.order));

                this.setordercourses();




            },
            gotoorder()
            {
                this.orderoverlay=true;
                this.orderoverlayPlain=true;
                this.overlaycocacola=true;
                //this.setTypes();
                this.setordercourses();
                //this.$router.push({'name':'order'});
                this.orderdialog=1;
                this.orderoverlay=false;
                this.orderoverlayPlain=false;
                this.overlaycocacola=false;
            },

            checkitemfavorite(itemid,courseid)
            {
                let th=this;
                let res=false;

                    //alert(itemid+','+courseid);

                    th.order.items.forEach(function(item){
                        if(itemid==item.itemid && courseid==item.courseid)
                        {
                            res=true;
                            //alert(res);
                        }

                    });
                return res;

            },

            togglefav(itemid,courseid,coursename,price,img,title,subtitle,origprice)
            {
                let th=this;
                let res=false;
                console.log('itemid' + itemid + ' courseid ' + courseid + ' coursename ' + coursename + ' price ' + price );
                this.fooditemid=itemid;
                if(th.order.items.length>0)
                {
                    let itemfound=false;
                    th.order.items.forEach(function(item,index){
                        if(itemid==item.itemid && courseid==item.courseid)
                        {

                            //th.order.items.pop({'itemid':th.fooditemid,'image':th.fooditem.fimage,'title':th.fooditem.title,'subtitle':th.fooditem.subtitle,'courseid':course.cid,'course':course.coursename,'qty':itemqty,'price':course.price,'total':itemtotal});
                            th.order.items.splice(index,1);

                            localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));
                            itemfound=true;
                            console.log('order minus');
                        }

                    });
                    if(!itemfound)
                    {

                        th.order.items.push({'itemid':itemid,'image':img,'title':title,'subtitle':subtitle,'courseid':courseid,'course':coursename,'qty':1,'price':price,'total':price,'type':'retail','origprice':origprice});
                        //res=false;
                        localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));
                        this.addtoorder();
                    }
                }
                else
                {
                    th.order.items.push({'itemid':itemid,'image':img,'title':title,'subtitle':subtitle,'courseid':courseid,'course':coursename,'qty':1,'price':price,'total':price,'type':'retail','origprice':origprice});
                            //res=false;
                    localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));
                    this.addtoorder();


                }


            },

            addtoorder()
            {

                console.log('Call Addorder');
                let th=this;
                let qty=0;
                th.fooditem.courses.forEach(function(course)
                {
                //let itemqty=parseInt(document.getElementById('course-'+course.courseid).value);
                let itemqty=1;
                qty=qty+itemqty;
                let itemprice=parseFloat(document.getElementById('course-'+course.courseid).getAttribute('data-price'));
                let itemtotal=itemprice*itemqty;
                if(itemtotal>0)
                {
                    console.log('cid'+course.cid);
                    //th.order.items.push({'itemid':th.fooditemid,'image':th.fooditem.fimage,'title':th.fooditem.title,'subtitle':th.fooditem.subtitle,'courseid':course.cid,'course':course.coursename,'qty':itemqty,'price':course.price,'total':itemtotal});
                }

                })
                localStorage.setItem('order-'+th.business.id,JSON.stringify(th.order));

                console.log('fooditemid'+this.fooditemid)  ;

                if(qty==0)
                {
                    qty=1;
                }
                this.$http
                .get(this.$apidomain+"itemorderedupdate/"+this.fooditemid+'/'+qty+'/plus')
                .then(res => {

                })
                .catch(err => {
                console.log(err.response);
                });


                // this.resetfoodtem();
                //  this.itemdialog=false;
                //  this.overlayfooditem=false;

            },

            setordercourses(){

                if(this.order.items.length>0)
                {
                    let th=this;
                    th.ordercourses={'courses':[{'items':[]}]};

                    th.order.items.forEach(function(item,index){
                        if(th.ordercourses.courses.length==0){
                            let cr={
                                courseid:item.courseid,
                                coursename: item.course,
                                type:item.type,
                                items:[]
                            };
                            cr.items.push(item);
                            th.ordercourses.courses.push(cr);
                        }
                        else{
                            let coursefound=false;
                            th.ordercourses.courses.forEach(function(course,ind){
                                if(course.courseid==item.courseid && course.type==item.type){
                                // course.items.push($item);
                                    th.ordercourses.courses[ind].items.push(item);
                                    coursefound=true;
                                }
                            });
                            if(!coursefound){
                                let cr={
                                    courseid:item.courseid,
                                    coursename: item.course,
                                    type:item.type,
                                    items:[]
                                };
                                cr.items.push(item);
                                th.ordercourses.courses.push(cr);
                            }
                        }
                    });
                }
                else
                {
                    this.ordercourses={'courses':[{'items':[]}]};

                }
            },

            gotoorder()
            {
                this.orderoverlay=true;
                this.setordercourses();
                //this.$router.push({'name':'order'});
                this.showpayment=0;
                this.orderdialog=1;
                this.orderoverlay=false;
            },

            setordertype()
            {

                localStorage.setItem('order-'+this.business.id,JSON.stringify(this.order));

                this.setordercourses();

                if(this.order.ordertype=='Delivery')
                {
                    //alert('delivery');
                    this.orderpanel=0;
                }
                else
                {
                    this.orderpanel=1;

                }
            },

            backtomenuorder()
            {
                this.orderdialog=0;

            },

            retailitemdetails(retailitemid,crid,type,sep)
            {
                if(sep){
                  return false;
                }

                this.itemdialog=true;



                if(type=='retail')
                {

                    //this.itemoverlayPlain=true;

                    this.orderoverlayPlain=true;

                    this.$http
                    .get(this.$apidomain+"retailitemDatanew/"+retailitemid)
                    .then(res =>
                    {
                        this.retailitem = res.data.Retailitem;

                        this.retailitemid = retailitemid;

                        this.itemdialog=true;


                        this.orderoverlayPlain=false;
                        this.itemoverlayPlain=false;
                    })
                    .catch(err => {
                        console.log(err.response);
                        this.orderoverlayPlain=false;
                        this.itemoverlayPlain=false;


                    });

                }





            },

            itembacktomenu()
            {
                this.itemdialog=false;
                this.itemoverlayPlain=false;
            },

            retailitemimage(fiid,showonmenu)
            {
                if(this.itemdialog)
                {
                    this.itemdialog=false;
                }
                if(this.orderdialog)
                {
                    this.orderdialog=false;
                }
                this.itemimagedialog=true;
                this.itemupdateid=fiid;
                this.fooditemshowonmenu=showonmenu;
                this.retailitemshowonmenu=showonmenu

            },

            logout()
            {
                this.$store.dispatch("logout").then(() => {
                    this.$router.push("/");
                });
            },

            backtomenuimage()
            {
                this.itemimagedialog=false;
                this.overlayfooditem=false;

            },

            onChange({coordinates, canvas})
            {

                this.coordinates = coordinates
                // You able to do different manipulations at a canvas
                // but there we just get a cropped image
                this.image = canvas.toDataURL()
                this.mainimguploading=false;

            },

            uploadImage(event)
            {
                // Reference to the DOM input element
                var input = event.target;
                // Ensure that you have a file before attempting to read it
                if (input.files && input.files[0]) {
                        this.mainimguploading=true;

                        // create a new FileReader to read this image and convert to base64 format
                        var reader = new FileReader();
                        // Define a callback function to run, when FileReader finishes its job
                        reader.onload = (e) => {
                                // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
                                // Read image as base64 and set to imageData
                                this.uploadedimage = e.target.result;
                        }
                        // Start the reader job - read file as a data url (base64 format)
                        reader.readAsDataURL(input.files[0]);
                }
            },

            updateimage()
            {
                let fd = new FormData(document.getElementById("editretailitem"));

                if(this.uploadedimage!=null){
                    fd.append('imagea',this.dataURLtoFile(this.image,document.getElementById('itemimage').files[0].name));
                }

                this.overlayfooditemimageupdate=true;

                this.$http
                .post(this.$apidomain+"updateretailItemImage/"+this.itemupdateid, fd)
                .then(res => {
                    if(res.data.success==1)
                    {

                        this.itemimagedialog=false;
                        this.overlayfooditemimageupdate=false;


                        // this.$router.push({name:'food',params:{tag:this.business.id,key:''}});
                        // this.$router.push({name:'businessfoodlist'});
                        this.$router.go('/');

                    }
                    else
                    {
                        this.overlay=false;
                        this.itemimagedialog=false;

                        let errmsg=[];
                        for(var prop in res.data.errors){
                            errmsg.push(res.data.errors[prop][0]);
                        }
                        alert(errmsg[0]);
                    }
                })
                .catch(err => {
                        this.overlay=false;

                        console.log(err.response);
                });

            },

            updateshowitem(itemid,showitem)
            {


                    this.$http
                    .post(this.$apidomain+"updateretailitemshow/"+itemid,{showitem:showitem})
                    .then(res => {
                        if(res.data.success==1)
                        {


                            this.$router.go('/');
                        }



                    })
                    .catch(err => {
                        console.log(err.response);
                        //this.overlay=false;

                    });

            },

            dataURLtoFile(dataurl, filename)
            {

                    var arr = dataurl.split(','),
                        mime = arr[0].match(/:(.*?);/)[1],
                        bstr = atob(arr[1]),
                        n = bstr.length,
                        u8arr = new Uint8Array(n);

                    while(n--){
                        u8arr[n] = bstr.charCodeAt(n);
                    }

                    return new File([u8arr], filename, {type:mime});
            },
        }
    }

</script>

<style>

    .retailmain .row-reset{
        margin: 0px;
        padding: 0px;

    }

    .retailmain .heart-cart-icon{
        text-align: center;
        align-items: center !important;
        display: flex;
        justify-content: center;
    }

    .retailmain .heart-cart-icon{
        text-align: center;
        align-items: center !important;
        display: flex;
        justify-content: center;
    }


    .retailmain .favorite-count-cart{
        display: flex;
        justify-content: center;
        color:rgb(255, 255, 255);
        position:relative;
        left: 50%;
        top: -8%;
        font-size: 8px;
        font-weight: 600;
        z-index:8;
        text-align: center;
    }

    .retailmain .favorite-count-heart{
        display: flex;
        color: rgb(255, 255, 255);
        position: relative;
        left: 50%;
        top: -3%;
        font-size: 10px;
        font-weight: 600;
        z-index: 8;
    }
/* ################ LIST VIEW CLASSES START HERE  */

    .divider-line.noimagecard {
        border-bottom: 1px #f3f3f3 solid;
        border-top: 1px #f3f3f3 solid;
        box-shadow: 0px 1px 1px #f3f3f3;

    }

    .retailmain .card-border-listView
    {
        border-top-left-radius: 10px;
        border-top-right-radius: 0px;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
    }

    .retailmain .image-listView
    {
        justify-content: center;
        text-align: center;
    }

    .fooddesc
    {
        font-size:12px;
        font-weight: 500;
    }

    .retailmain .prod-code-listView{
        /* padding-top: 10px; */
        color: #fe5800;
        font-size:8px;
		font-weight: 300;
        text-transform:uppercase;
        text-align: right;
        padding-top: 5px;
        padding-left: 0px;
        padding-right: 0px;
        margin: 0px;
    }

    .retailmain .title-listView
    {
        font-size:14px !important;
        line-height: 14px;
        font-weight:800;
        color: rgb(61,61,61);
        text-transform:uppercase;
        text-align: left;
        padding: 0px;

    }

    .retailmain .subtitle-listView{
        /* padding-top: 10px; */
        color: rgb(61, 61, 61);
        font-size:12px;
		font-weight: 400;
        text-transform:capitalize;
        line-height: 12px;
        text-align: left;
        padding: 0px;
    }

    .retailmain .brand-listView{
        /* padding-top: 10px; */
        color: rgb(61,61,61);
        font-size:10px;
		font-weight: 400;
        text-transform:uppercase;
        line-height: 12px;
        text-align: left;
        padding: 0px;
    }


    .retailmain .description-listView{

        font-size:10px;
        font-weight: 300;
        line-height:10px;
        text-align: justify;
        color: rgb(48, 48, 48);
        padding: 0px;


    }

    .justify-evenly{
        justify-content: space-evenly;
    }
    .sep-text-center{
        text-align: center;
    }

    .retail-price-section{

        position: absolute;
        bottom: 10px;
        left: 0px;
        right: 0px;


    }

    .retailmain .price-row-listView{
        font-size:9px !important;
        line-height: 1 !important;
        padding-top: 10px;
        padding-bottom: 10px;
        padding-left: 0px !important;
        padding-right: 0px !important;
        /* justify-content: space-evenly; */
        align-items: baseline;

    }

    .retailmain .price-listView{

        font-weight:300;
        color: #989898;
        padding-top: 0px;
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 3px;
        padding-right: 0px;
        /* text-align: right; */
    }

/* Portion Text  */
    .retailmain .size-portion-text-listView
    {
        /* font-size: 9px !important;
        line-height: 9px !important; */
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px;
        padding-right: 0px;
        font-weight:300;
        color: #989898;
        text-transform:uppercase;
        text-align: left;
    }

/* New Price - Now Price  */
    .retail-sale-price-listView
    {
        font-weight:300;
        font-size: 12px;
        padding-top: 0px;
        padding-bottom: 0px;
        color: #989898;
        outline-style: thin;
        stroke-width: 2px;
        background-color: none !important;
        padding-left: 0px;
        padding-right: 0px;
        border-top-left-radius: 1px;
        border-top-right-radius: 1px;
        border-bottom-left-radius: 1px;
        border-bottom-right-radius: 1px;
        margin-right: 0px;
        /* text-align: right; */
    }

    .retail-discount-listView
    {
        /* font-size:9px !important; */
        background-color: crimson;
        color: white !important;
        font-weight:600;
        padding-top: 2px;
        padding-bottom: 2px;
        padding-right: 2px;
        padding-left: 2px;
        border-radius: 3px;
        /* color: #ff0303; */
        text-align: right;
    }

/* This is the striked through price shown when an item is discounted  */
    .retailmain .was-price-listView
    {
        padding-top: 0px;
        padding-bottom: 0px;
        padding-right: 0px;
        margin-right: 5px;
        font-size: 12px;
        font-weight:300;
        color: #989898;
        text-decoration:none;
        /* text-decoration-color: #FE5800; */
        /* text-align: right; */
    }
    .retailmain .sale-price-listView
    {
        padding-top: 0px;
        padding-bottom: 0px;
        padding-right: 0px;
        margin-right: 5px;
        font-size: 12px;
        font-weight:300;
        color: #989898;
        text-decoration:none;
        /* text-decoration-color: #FE5800; */
        /* text-align: right; */
    }



    .strikethrough {
    position: relative;
    }

    .strikethrough:before {
    position: absolute;
    content: "";
    left: 0;
    top: 50%;
    right: 0;
    border-top: 1px solid;
    border-color: #FE5800;

    -webkit-transform:rotate(-10deg);
    -moz-transform:rotate(-10deg);
    -ms-transform:rotate(-10deg);
    -o-transform:rotate(-10deg);
    transform:rotate(-10deg);
    }

/* LIST VIEW CLASSES END HERE  */



/* ################ GRID VIEW CLASSES START HERE  */

    .retailmain .row-gridView {
        padding-top: 0px !important;
        padding-bottom: 0px !important;
        padding-left: 20px !important;
        padding-right: 20px !important;
        margin-top: 0px !important;
        margin-bottom: 0px !important;
        margin-left: 0px !important;
        margin-right: 0px !important;

    }


    .retailmain .card-shape--gridView
    {
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        border-bottom-left-radius: 3px;
        border-bottom-right-radius: 3px;
        padding: 0px;
    }

    .retailmain .image-gridView
    {
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        border-bottom-left-radius: 0px;
        border-bottom-right-radius: 0px;
    }


    .retailmain .title--gridView
    {
        font-size:14px !important;
        line-height: 13px !important;
        font-weight:600;
        /* color: rgb(20, 20, 20); */
        text-transform:uppercase;
        padding-top: 10px;
        padding-bottom: 0px;
        padding-left: 0px !important;
        padding-right: 0px;
    }

    .retailmain .subtitle-gridView
    {
        font-size:10px;
		font-weight: 600;
        line-height: 11px;
        padding-top: 1px;
        padding-bottom: 0px;
        padding-left: 0px !important;
        padding-right: 0px;
        /* color: rgb(60, 60, 60); */
        text-transform:uppercase;

    }


    .retailmain .description-gridView
    {
        font-size:10px;
        font-weight: 300;
        line-height: 10px !important;
        text-align: justify;
        max-block-size: 80%;
        /* color: rgb(48, 48, 48); */
        padding-top: 3px;
        padding-bottom: 0px;
        padding-left: 0px !important;
        padding-right: 0px !important;

        /* max-height: 100px; */

    }

    .retailmain .price-row-gridView
    {
        font-size:9px !important;
        line-height: 9px !important;
        font-weight:300;
        /* color: #414141; */
        padding-top: 0px;
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 12px;
        padding-right: 0px;
    }


    .size-portion-text-gridView
    {

        background-color: none !important;
        font-weight:300;
        font-size: 9px;
        /* color: #414141; */
        text-transform:capitalize;
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px;
        padding-right: 0px;
    }

    .special-offer-price-gridView
    {
        background-color: none !important;
        font-weight:300;
        font-size: 9px;
        /* color: #414141; */
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px !important;
        padding-right: 0px;
        border-top-left-radius: 1px;
        border-top-right-radius: 1px;
        border-bottom-left-radius: 1px;
        border-bottom-right-radius: 1px;

    }


    .retailmain .was-price--gridView
    {
        background-color: none !important;
        font-weight:300;
        font-size: 9px;
        /* color: #414141; */
        text-decoration:none;
        /* text-decoration-color: #fe0000; */
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px;
        padding-left: 0px;
    }

    .retailmain .price-text-gridView
    {
        background-color: none !important;
        font-weight:300;
        font-size: 9px;
        /* color: #414141; */
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px !important;
        padding-right: 0px;
        border-top-left-radius: 1px;
        border-top-right-radius: 1px;
        border-bottom-left-radius: 1px;
        border-bottom-right-radius: 1px;

    }


/* GRID VIEW CLASSES END HERE  */



/* ################ DETAIL CARD CLASSES START HERE ################ */

    .retailmain .detail-card-retail{
        margin: 0px  !important;
        padding: 0px !important;
        background-color: #fe0000 !important;

    }

    .retailmain .detail-card-border
    {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
    }

    .retailmain .detail-card-photo
    {
        /* max-height: 400px; */
        border-top-left-radius: 10px;
        border-top-right-radius: 0px;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 0px;
    }

    .retailmain .detail-card-section{
        color: rgb(255, 255, 255);
        background-color:#082a5e;
        font-size:12px;
		line-height: 12px;
        font-weight: 500;
        text-align: left;
        padding-left: 10px;
        padding-right: 10px;
        padding-top: 5px;
        padding-bottom: 5px;
        text-transform:capitalize;
        vertical-align: middle;
        border-radius: 0px;
    }

    .retailmain .detail-card-chef-banner
    {
        border-top-right-radius: 25px !important;
        border-top-left-radius: 25px !important;
        position:absolute;
        bottom:0px;
        left:0px;
        text-align:center;
        width:100%;
        height:41px;
        line-height:41px;
    }

    .retail-detail-prod-code{
        /* padding-top: 10px; */
        color: rgb(109, 0, 0);
        font-size:10px;
		font-weight: 400;
        text-transform:uppercase;
        text-align: right;
        padding-top: 5px;
        padding-left: 0px !important;
        padding-right: 12px !important;
        margin: 0px !important;
    }

    .retailmain .detail-card-allergen-icon-text
    {
        font-size:10px !important;
        line-height: 1 !important;
        font-weight:200;
        color: rgb(44, 44, 44);
        text-transform:uppercase;
        padding-top: 5px;
        padding-bottom: 5px;
        text-align: center;


    }

    .retailmain .display-allergens
    {
        color: rgb(42, 42, 42);
        font-size:12px;
		font-weight: 300;
        text-transform:capitalize;
        padding-left: 5px;
        padding-right: 5px;
        padding-top: 5px;
        padding-bottom: 5px;
        text-align: center;
        /* vertical-align: middle; */
        vertical-align: text-top;
        line-height: 10px;

    }


    .retail-detail-card-title
    {
        font-size:24px !important;
        line-height: 24px !important;
        font-weight:800;
        color: rgb(44, 44, 44);
        text-transform:uppercase;
        padding-top: 1px;
        padding-bottom: 0px;

        }
    .retail-detail-card-subtitle
    {
        color: rgb(110, 110, 110);
        font-size:18px !important;
        font-weight:400;
        padding-top: 0px;
        padding-bottom: 0px;

    }


    .retail-detail-card-description
    {
        color: rgb(48, 48, 48);
        padding-top: 10px;
        padding-bottom:0;
        padding-left: 12px;
        padding-right: 12px;
        margin-bottom: 0;
        font-size:12px;
        font-weight: 300;
        line-height:1;
        text-align: justify;


    }

    .retailmain .detail-card-price-row{
        padding-top: 0px !important;
        padding-bottom: 0px !important;
        padding-left: 0px !important;
        padding-right: 0px !important;
        margin-top: 0px !important;
        margin-bottom: 0px !important;
        margin-left: 0px !important;
        margin-right: 0px !important;
        text-align: right;
        line-height: 10px !important;
        align-items: center;
    }


    .retailmain .detail-card-food-portion-text
    {
        font-size:9px !important;
        line-height: 10px !important;
        font-weight:300;
        color: #949494;
        padding-top: 0px !important;
        padding-bottom: 0px !important;
        padding-left: 0px !important;
        padding-right: 0px !important;
        text-align: left;
    }


    .retail-detail-card-item-price
    {
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px;
        padding-right: 12px;
        font-size:12px !important;
        line-height: 10px !important;
        font-weight:300;
        color: #949494;
        text-align: right;
        /* text-transform:uppercase;         */
    }

    .retailmain .detail-card-now-price
    {
        color: #949494;
        outline-style: thin;
        stroke-width: 2px;
        background-color: none !important;
        font-weight:300;
        font-size: 9px;
        padding-top: 0px !important;
        padding-bottom: 0px !important;
        padding-left: 2px;
        padding-right: 2px;
        border-top-left-radius: 1px;
        border-top-right-radius: 1px;
        border-bottom-left-radius: 1px;
        border-bottom-right-radius: 1px;
        margin-right: 0px;
        text-align: right !important;
        line-height: 10px !important;
    }

    .retailmain .detail-card-was-price
    {
        padding-top: 0px !important;
        padding-bottom: 0px !important;
        padding-right: 0px !important;
        font-size:9px !important;
        line-height: 10px !important;
        font-weight:300;
        color: #949494;
        text-decoration:none;
        /* text-decoration-color: #FE5800; */
        text-align: right !important;
    }

    .retailmain .detail-card-paired-text
    {
        background-color: #082a5e ;
        color: rgb(255, 255, 255);
        padding-top: 15px !important;
        padding-bottom: 15px !important;
        padding-left: 10px !important;
        padding-right: 10px !important;
        margin-bottom: 0px;
        font-size:12px;
        font-weight: 400;
        /* line-height:1; */
        text-align: center;
    }

    .retailmain .detail-card-paired-row{
        font-size:9px !important;
        line-height: 9px !important;
        font-weight:300;
        color: #989898;
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px !important;
        padding-right: 0px !important;
        margin: 0px !important;
        justify-content: flex-end;
        align-items: center;
        text-align: right;

    }


/* CSS FOR PAIRD DRINKS ON FOOD DETAIL CARD  */


    .retailmain .detail-card-measurement{
        font-size: 8px;
        padding: 0px;
        text-align: left;
        line-height: 1;
    }

    .retailmain  .detail-card-unit{
        font-size: 8px;
        padding: 0px;
        text-align: left;
        line-height: 1;
    }

    .retailmain  .detail-card-price{
        font-size: 8px;
        padding: 0px;
        text-align: right;
        line-height: 1;
    }
/* ################ DETAIL CARD CLASSES END HERE ################ */


    .retailmain  .heart
    .retailmain  .close-icon{
        position:absolute;
        top:15pxs;
        right:15px;
        width: 24px;
        height: 24px;
        z-index: 9999;
        font-size: 20px;
    }
    .retailmain .fborder{
        border:5px solid #FE5800 !important;
    }
    .retailmain .cheficon{
        position:absolute;
        top:3;
        right:0px;
        width: 20px;
        z-index: 4;
    }
    .retailmain .srch .v-text-field__details{
    display:none;
    }
    .retailmain  .vue-sticky-el.top-sticky{
        width:100% !important;
        left: 0 !important;
        height:60px;
        margin-left: 0px;
        margin-right: 0px;
    }
    .retailmain .titledivider{
        position:relative;
        height: 50px;
        background-color:#FE5800 ;
    }
    .retailmain .titledivider:before{
    position:absolute;
    content:"";
    height:2px;
    background:#f3db05;
    top:50%;
    left:0px;
    right:0px;
    z-index: 1;
    }


    .retailmain .titlecontent
    {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 999;
    }


    .retailmain .ovr
    {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 999999;

    }


    .retailmain .row{
        /* margin-right: 0px !important;
        margin-left: 0px !important; */
        text-decoration: none;
    }

    .retailmain .grid-list-icons{
        text-align: center;
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 0px;
        padding-right: 0px;
        margin-left: 0px;
        margin-right: 0px;
    }

    .saleitemcorner{
        z-index: 4;
        position: absolute;
        top: -11px;
        left: -10px;
        width: 124px;
    }

    .sale-text{
        z-index: 4;
        color: white;
        font-size: 24px;
        font-weight: 900;
        /* transform-origin: 0 0; */
        transform: rotate(-45deg);
        position: absolute;
        top: 10px;
        left: -8px;
        text-align: right;
    }
    .sale-text-x{
        z-index: 4;
        color: white;
        font-size: 24px;
        font-weight: 900;
        /* transform-origin: 0 0; */
        transform: rotate(-45deg);
        position: absolute;
        top: 11px;
        left: -2px;
        text-align: right;
    }
    .retailitem-separation-list-view-title{
     color: #ffffff !important;
    font-size: 20px !important;
    font-weight: 800 !important;
    text-align: center !important;
    padding-top: 5px !important;
    padding-bottom: 0px !important;

    }

    .retailitem-separation-list-view-subtitle{
        /* padding-top: 10px; */
        color: rgb(255, 255, 255);
        font-size:12px;
		font-weight: 400;
        text-transform:capitalize;
        line-height: 12px;
        text-align: center;
        padding-bottom: 12px;
        padding-top: 0px;
    }

    .sales-text-hidden{
        opacity: 0;
    }
    .saleribbon{
        z-index: 4;
        position: absolute;
        top: -4px;
        right: 37px;
        width: 50px;
    }


    .retailmain .powered-by-juzzap{
        font-size: 8px;
        font-weight: 300;
        color: #FE5800;
        padding-top: 0px;
        padding-bottom: 10px;
        padding-right: 5px;
        text-align: right;
        /* position: absolute; */
    }

    /* ANIMATION STYLING  */


    .retailmain .imagezoomfast .v-image__image.v-image__image--cover{
    animation: beat 35s infinite alternate;
    /* animation:scale 60s forwards; */
    transform-origin:50% 50%;
    transform:scale(1);
    }


    .retailmain .imagezoomslow .v-image__image.v-image__image--cover{
    animation: beat 30s infinite alternate;
    /* animation:scale 75s forwards; */
    transform-origin:50% 50%;
    transform:scale(1);
    }

    @keyframes beat{
        to { transform: scale(1.4); }
    }

    @keyframes scale {
    100% {
        transform:scale(1.5);
    }
    }

    /* PULSE ANIMATION  */

    .retailmain .pulse-banner {
    /* margin:100px; */
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    /* background: #fe5800; */
    /* cursor: pointer; */
    /* box-shadow: 0 0 0 rgba(218, 94, 12, 0.4); */
    animation: pulse .5s;
    animation-iteration-count: 20;
    }
    .retailmain .pulsex7:hover {
    animation: none;
    }
    @-webkit-keyframes pulse {
    0% {
        -webkit-box-shadow: 0 0 0 0 rgba(254, 88, 0 , 0.4);
    }
    70% {
        -webkit-box-shadow: 0 0 0 10px rgba(254, 88, 0, 0);
    }
    100% {
        -webkit-box-shadow: 0 0 0 0 rgba(254, 88, 0, 0);
    }
    }
    @keyframes pulse {
    0% {
        -moz-box-shadow: 0 0 0 0 rgba(254, 88, 0, 0.4);
        box-shadow: 0 0 0 0 rgba(254, 88, 0, 0.4);
    }
    70% {
        -moz-box-shadow: 0 0 0 10px rgba(254, 88, 0, 0);
        box-shadow: 0 0 0 10px rgba(254, 88, 0, 0);
    }
    100% {
        -moz-box-shadow: 0 0 0 0 rgba(254, 88, 0, 0);
        box-shadow: 0 0 0 0 rgba(254, 88, 0, 0);
    }
    }

    .retailmain .pulsex7 {
    /* margin:100px; */
    /* display: block; */
    /* width: 30px; */
    /* height: 30px; */
    border-radius: 50%;
    /* background: #fe5800; */
    /* cursor: pointer; */
    /* box-shadow: 0 0 0 rgba(218, 94, 12, 0.4); */
    animation: pulse 2s;
    animation-iteration-count: 7;
    }


    .retailmain .pulsex7:hover {
    animation: none;
    }
    @-webkit-keyframes pulse {
    0% {
        -webkit-box-shadow: 0 0 0 0 rgba(254, 88, 0 , 0.4);
    }
    70% {
        -webkit-box-shadow: 0 0 0 10px rgba(254, 88, 0, 0);
    }
    100% {
        -webkit-box-shadow: 0 0 0 0 rgba(254, 88, 0, 0);
    }
    }
    @keyframes pulse {
    0% {
        -moz-box-shadow: 0 0 0 0 rgba(254, 88, 0, 0.4);
        box-shadow: 0 0 0 0 rgba(254, 88, 0, 0.4);
    }
    70% {
        -moz-box-shadow: 0 0 0 10px rgba(254, 88, 0, 0);
        box-shadow: 0 0 0 10px rgba(254, 88, 0, 0);
    }
    100% {
        -moz-box-shadow: 0 0 0 0 rgba(254, 88, 0, 0);
        box-shadow: 0 0 0 0 rgba(254, 88, 0, 0);
    }
    }

    /* SQUARE PULSE  MICRO ANIMATION */

    .retailmain .pulseBox {
    /* margin:100px; */
    display: block;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    /* background: #fe5800; */
    /* cursor: pointer; */
    /* box-shadow: 0 0 0 rgba(218, 94, 12, 0.4); */
    animation: pulse 1s;
    animation-iteration-count: 3;
    }
    .retailmain .pulsex7:hover {
    animation: none;
    }
    @-webkit-keyframes pulse {
    0% {
        -webkit-box-shadow: 0 0 0 0 rgba(254, 88, 0 , 0.4);
    }
    70% {
        -webkit-box-shadow: 0 0 0 10px rgba(254, 88, 0, 0);
    }
    100% {
        -webkit-box-shadow: 0 0 0 0 rgba(254, 88, 0, 0);
    }
    }
    @keyframes pulse {
    0% {
        -moz-box-shadow: 0 0 0 0 rgba(254, 88, 0, 0.4);
        box-shadow: 0 0 0 0 rgba(254, 88, 0, 0.4);
    }
    70% {
        -moz-box-shadow: 0 0 0 10px rgba(254, 88, 0, 0);
        box-shadow: 0 0 0 10px rgba(254, 88, 0, 0);
    }
    100% {
        -moz-box-shadow: 0 0 0 0 rgba(254, 88, 0, 0);
        box-shadow: 0 0 0 0 rgba(254, 88, 0, 0);
    }
    }

    .fixed-position{
        position: absolute;
        bottom: 15px !important;
    }
.product-quantity-input{
    background-color: #eee;
    border: none;
    width:2.5em;
    text-align: center;}

    .retail-order-card-image{
        align-content: stretch;
        vertical-align: middle;
        max-width: 100%;

    }
    .retails-order-card-price-section{
        position: absolute;
        bottom: 0px;
        right: 0px;

    }
    .max-400{
        max-width:400px !important;
        align-items: flex-start;
    }

</style>
